<template>
  <!--    <div class="g_s-item clearBoth" @click.stop="onSelectItem(item)">-->
  <div
    class="g_s-item clearBoth"
    :class="{disabled:item.status >= 2}"
    @click.stop="onSelectItem(item)"
  >
    <div
      v-if="(type === 5 && item.lottery_type!==3) || (type===1 && item.lottery_type!==3 && (item.class1!=='冠亚和' && item.class1!=='两面' && item.class1!=='方位' && item.class1!=='总和') )"
      class="s_item-label"
    >
      <span :class="['number3'+item.label]"></span>
    </div>
    <div v-else-if="item.lottery_type!==3 && type !== 4" class="s_item-label">
      <span
        :class="[
          'number' +  (type === 5 ? 3 : type),
           type !== 1 && checkNumber(item.label) ? 'number' + (type === 5 ? 3 : type)  + item.label : ''
           ]"
      >{{showLabel(item.label)}}</span>
    </div>
    <div
      v-else-if="item.lottery_type===3 && type !== 4 && (item.class1==='两面'||item.class1==='方位'||item.class1==='总和')"
      class="s_item-label"
    >
      <span :class="['number3'+item.label]">{{showLabel(item.label)}}</span>
    </div>

    <div
      v-else-if="item.lottery_type===3 && type !== 4 && item.class1!=='两面' && item.class1!=='方位' && item.class1!=='总和'"
      class="s_item-label"
    >
      <span :class="['number2 '+'numbernc'+item.label]"></span>
    </div>

    <div v-if="type !== 5" class="s_item-rate" :class="{ change:item.ischange }">{{item.rate}}</div>

    <div class="s_item-auto">
      <input
        v-if="(name === 'g_input_selected_item')"
        ref="input"
        class="s-inner t-block"
        v-model="value"
        :disabled="item.status >= 2"
        :class="{active: selected}"
      />
      <i v-else :class="{active: selected}" class="s-inner t-block inner-5"></i>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex";
  import ObjectPath from "object-path";
  import Vue from "../../../utils/bus";

  /***
   * name：g_input_selected_item 不可变
   * 通过 g_input_selected_item 逐级向下查找组件进行数据操作
   */
  export default {
    name: "selected_item",
    props: {
      // 允许选中条件，默认允许选中
      selectRule: {
        type: Function,
        default() {
          return true;
        }
      },
      chip: String,
      type: {
        type: Number,
        default: 1
        // 1 => 文字 + 比率 + 选择框
        // 2 => 数字1 || 文字 + 比率 + 选择框
        // 3 => 数字2 || 文字 + 比率 + 选择框
        // 4 =>               比率  + 选择框
        // 5 => 数字2          + 选择框
      },
      item: {
        type: Object,
        default() {
          return {
            label: "大",
            rate: 1.998,
            selected: false
          };
        }
      },
      isSelectAll: Boolean,
      isWatch: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },
    computed: {
      ...mapState({
        curTab: state => state.home_PK10.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_PK10.tabs,
        odds: state => state.home_PK10.odds,
        lottery: state => state.home_PK10.lottery,
        order_history: state => state.home_PK10.order_history,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      })
    },
    watch: {
      item: {
        immediate: true,
        deep: true,
        handler() {
          const {id} = this.item;
          const values = this.$store.state.table.inputValues;
          const value =
            ObjectPath.get(values, `${id}`) || this.item.status === 3
              ? "封盘中"
              : "";
          this.value = this.item.status === 3 ? "" : this.value;
          this.selected = this.item.status === 3 ? false : this.selected;
          this.saveInputValie({value: {[id]: value}});
        }
      },
      'item.rate':function(val,oldval){
        this.item.ischange=true
      },//键路
      value: {
        handler(e) {
          if (e) {
            const {id} = this.item;
            this.saveInputValie({value: {[id]: e}});
            this.selected = true;
          }
        }
      },
      isSelectAll(data) {
        if (this.isWatch) {
          if (data && Number.isInteger(parseInt(this.item.label))) {
            this.selected = true;
            this.value = this.$store.state.inputnum;
          } else {
            this.selected = false;
            this.value = "";
          }
        }else{//快乐十分
          if ( ! data && Number.isInteger(parseInt(this.item.label))) {
            //this.selected = true;
            this.value = this.$store.state.inputnum;
          } else {
            //this.selected = false;
            this.value = "";
          }
        }
      }
    },
    data() {
      return {
        selected: false,
        value: ""
      };
    },
    computed: {
      name() {
        // 为5不可选中
        return this.type === 5
          ? "g_input_selected_item_type_2"
          : "g_input_selected_item";
      }
    },
    methods: {
      ...mapActions("table", {
        saveInputValie: "saveInputValie"
      }),
      showLabel(label) {
        if (this.type === 1) {
        } else {
          if (this.checkNumber(label)) label = "";
        }
        return label;
      },
      onSelectItem(item) {
        if (item.status >= 2) return;
        if (!this.selectRule(this.type, !this.selected)) return;
        this.selected = !this.selected;
        if (
          this.name === "g_input_selected_item" ||
          this.name === "g_input_selected_item_type_2"
        ) {
          this.value = this.selected ? this.chip : "";
        }
        this.$refs.input && this.$refs.input.focus();
	if(this.selected)
	{
	    this.value=this.$store.state.inputnum;	
	}
      },
      checkNumber(str) {
        const n = Number(str);
        return typeof n === "number" && n.toString() !== "NaN";
      }
    },
    created() {
      if (this.isSelectAll && Number.isInteger(parseInt(this.item.label))) {
        this.selected = true;
      }
    }
  };
</script>

<style scoped lang="stylus">
  // 修改
  .s-inner {
    text-align: center;
    outline: none;
  }

  .number-type-2 {
    .number1 {
      background-image: url('');
    }
  }

  $border_d-color = #e6e6e6;

  .g_s-item {
    cursor: pointer;
    height: 26px;
    display: flex;
    font-weight: bold;
    line-height: 26px;
    border-bottom: 1px solid $border_d-color;

    &:hover {
      background-color: #eff1ea;
    }

    &.disabled {
      background-color: #efefef;
      cursor: no-drop;
    }

    div {
      flex: 1;
      height: 100%;
      padding: 0 5px;
      text-align: center;
      box-sizing: border-box;
    }

    > div + div {
      border-left: 1px solid $border_d-color;
    }

    .s_item-label {
      width: 60px;
      display: flex;
      font-weight: 500;
      align-items: center;
      justify-content: center;

      .number3 {
        /* width 22px */
        height: 27px;
        line-height: 27px;
      }
    }

    .s_item-rate, .s_item-auto {
      color: #FF0000;
      font-weight: 500;
    }

    .change{
      background: #fffa00;
    }

    .s_item-auto {
      display: flex;
      align-items: center;
      justify-content: center;

      .s-inner {
        width: 100%;
        height: 20px;
        border: 1px solid #bfbfbf;
        display: inline-block;
        border-radius: 2px;
      }

      .s-inner[disabled] {
        background: $border_d-color;
        color: rgb(84, 84, 84);
      }

      .inner-5 {
        height: 15px;
        width: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-item/g_switch-item1.vue